export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./TextSlider.vue?vue&type=template&id=20d937f4&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/TextSlider.vue?vue&type=template&id=20d937f4&scoped=true&
// module id = 255
// module chunks = 0